import React, { useState } from "react";
import axios from "axios";

const GoogleGeminiPDF = () => {
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
      setError("");
    }
  };

  const processPDF = async () => {
    if (!file) {
      setError("Please select a PDF file first");
      return;
    }

    try {
      setLoading(true);
      setSummary("");
      setError("");

      // For browser environments, we need to use a different approach
      // You'll need a backend service to handle the file upload and Google AI processing
      
      // Create a FormData object to send the file to your backend
      const formData = new FormData();
      formData.append('pdf', file);
      
      // Send the file to your backend service
      const response = await axios.post('/api/process-pdf', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      // Get the summary from your backend response
      setSummary(response.data.summary);
    } catch (error) {
      console.error("Error processing PDF:", error);
      setError("Error occurred while processing the PDF. " + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Google Gemini AI PDF Summarizer</h1>
      
      <div style={{ margin: "20px 0" }}>
        <input 
          type="file" 
          accept=".pdf" 
          onChange={handleFileChange}
          style={{ marginBottom: "10px" }}
        />
        <button
          onClick={processPDF}
          disabled={loading || !file}
          style={{
            backgroundColor: "blue",
            color: "white",
            padding: "10px",
            borderRadius: "5px",
            marginLeft: "10px",
            cursor: loading || !file ? "not-allowed" : "pointer",
            opacity: loading || !file ? 0.7 : 1
          }}
        >
          {loading ? "Processing..." : "Summarize PDF"}
        </button>
      </div>

      {error && (
        <div style={{ color: "red", margin: "10px 0" }}>
          {error}
        </div>
      )}

      {summary && (
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#f9f9f9",
            textAlign: "left"
          }}
        >
          <h2>Summary:</h2>
          <p style={{ whiteSpace: "pre-wrap" }}>{summary}</p>
        </div>
      )}
    </div>
  );
};

export default GoogleGeminiPDF;
